var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDECEC",
    d: "M32 5H18v10h18V9a4 4 0 0 0-4-4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M11 5H4a4 4 0 0 0-4 4v6h11V5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDECEC",
    d: "M32 31H18V21h18v6a4 4 0 0 1-4 4zm-21 0H4a4 4 0 0 1-4-4v-6h11v10z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#003580",
    d: "M18 5h-7v10H0v6h11v10h7V21h18v-6H18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFi);
export default __webpack_public_path__ + "static/1781163949/media/fi.997e1474e5c1d2b594b582423a808dc3.svg";
export { ForwardRef as ReactComponent };